export default function setPagination(pagination) {
  return {
    total: Math.ceil(+pagination.total / +pagination.perPage),
    currentPage: +pagination.currentPage,
    totalItems: +pagination.total,
  }
}
